if (!customElements.get('favorite-collections')) {
  customElements.define(
    'favorite-collections',
    class FavoriteCollections extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.enableSlider = this.dataset.enableSlider === 'true';

        this.sectionId = this.dataset.sectionId;
        this.panelWrapper = this.querySelector('.favorite-collections__panel');
        this.visualWrapper = this.querySelector('.favorite-collections__visual');
        this.mediaWrapper = this.querySelector('.favorite-collections__media');

        this.PanelSlider = false;
        this.VisualSlider = false;
        this.MediaSlider = false;

        if (!this.enableSlider) return;

        this.initSlider();
      }

      initSlider() {
        this.initVisualSlider();
        this.initMediaSlider();
        this.initPanelSlider();
        this.initMobileNav();

        this.PanelSlider.slider.controller.control = [this.VisualSlider.slider, this.MediaSlider.slider];
        this.VisualSlider.slider.controller.control = this.PanelSlider.slider;

        this.PanelSlider.slider.on('slideChange', (swiper) => {
          const { slides, activeIndex } = swiper;
          const currentSlide = slides[activeIndex];

          this.refreshAnimation(this.VisualSlider.slider.slides[activeIndex]);
          this.refreshAnimation(this.MediaSlider.slider.slides[activeIndex]);
          this.updateControlsScheme(currentSlide);
          this.updateMobileNavState(swiper);
        });

        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId != this.sectionId) return;
            let { target } = e;
            const index = Number(target.dataset.index);

            this.PanelSlider.slider.slideToLoop(index);
          });
        }
      }

      initMobileNav() {
        this.mobileNavPrev = this.querySelector('.favorite-collections__nav-btn--prev');
        this.mobileNavNext = this.querySelector('.favorite-collections__nav-btn--next');

        if (!this.mobileNavPrev || !this.mobileNavNext || !this.PanelSlider?.slider) return;

        this.mobileNavPrev.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.PanelSlider.slider.slidePrev();
        });

        this.mobileNavNext.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.PanelSlider.slider.slideNext();
        });

        this.updateMobileNavState(this.PanelSlider.slider);
      }

      updateMobileNavState(swiper) {
        if (!this.mobileNavPrev || !this.mobileNavNext || !swiper) return;

        this.mobileNavPrev.classList.toggle('swiper-button-disabled', swiper.isBeginning);
        this.mobileNavPrev.toggleAttribute('disabled', swiper.isBeginning);
        this.mobileNavNext.classList.toggle('swiper-button-disabled', swiper.isEnd);
        this.mobileNavNext.toggleAttribute('disabled', swiper.isEnd);
      }

      initVisualSlider() {
        const sliderOptions = {
          slidesPerView: 1,
          loop: false,
          threshold: 2,
        };

        this.VisualSlider = new window.FoxTheme.Carousel(this.visualWrapper, sliderOptions, [
          FoxTheme.Swiper.Controller,
        ]);
        this.VisualSlider.init();
      }

      initMediaSlider() {
        const sliderOptions = {
          slidesPerView: 1,
          loop: false,
          threshold: 2,
          allowTouchMove: false,
        };

        this.MediaSlider = new window.FoxTheme.Carousel(this.mediaWrapper.querySelector('.swiper'), sliderOptions);
        this.MediaSlider.init();
      }

      initPanelSlider() {
        const sliderOptions = {
          slidesPerView: 1,
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            type: 'fraction',
            clickable: false,
            renderFraction(currentClass, totalClass) {
              return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`;
            },
          },
          loop: false,
          threshold: 2,
          on: {
            init: this.handlePanelSliderInit.bind(this),
          },
        };

        this.PanelSlider = new window.FoxTheme.Carousel(
          this.panelWrapper.querySelector('.swiper'),
          sliderOptions,
          [FoxTheme.Swiper.Controller]
        );
        this.PanelSlider.init();
      }

      updateControlsScheme(activeSlide) {
        if (!this.panelWrapper || !activeSlide) return;
        const classesToRemove = Array.from(this.panelWrapper.classList).filter((className) =>
          className.startsWith('color-')
        );
        classesToRemove.forEach((className) => this.panelWrapper.classList.remove(className));
        const colorScheme = activeSlide.dataset.colorScheme;
        if (colorScheme) {
          this.panelWrapper.classList.add(colorScheme);
        }
        const panelBackground = activeSlide.dataset.panelBackground;
        if (panelBackground) {
          this.panelWrapper.style.backgroundColor = panelBackground;
        }
      }

      handlePanelSliderInit(swiper) {
        const slide = swiper.slides[swiper.activeIndex];
        this.updateControlsScheme(slide);
      }

      refreshAnimation(activeSlide) {
        if (!activeSlide) return;
        activeSlide.querySelectorAll('motion-element').forEach((motionEl) => {
          setTimeout(() => {
            motionEl && motionEl.refreshAnimation();
          });
        });
      }
    }
  );
}
